import { ReactNode } from 'react';

import { CloseOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';
import { Col, Row, Select } from 'antd';
import { FilterFunc } from 'rc-select/lib/Select';

import { MFormItemError } from '../MFormItemError/MFormItemError';
import { MSpinner } from '../MSpinner/MSpinner';

import * as Styles from './MSelect.styles';

const { Option } = Select;

export interface MSelectProps {
  value?: string;
  options: { value: string; label: string | ReactNode }[];
  defaultValue?: string;
  onChange?: (value: string) => void;
  onSelect?: (value: string, option: { label: string; value: string }) => void;
  onDeselect?: (value: string) => void;
  onSearch?: (value: string) => void;
  error?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  name?: string;
  allowClear?: boolean;
  mode?: 'multiple' | 'tags';
  loading?: boolean;
  showSearch?: boolean;
  showArrow?: boolean;
  filterOption?: boolean | FilterFunc<{ label: string; value: string }>;
  testId?: string;
}

export const MSelect = ({
  value,
  options,
  defaultValue,
  onChange,
  onSelect,
  onDeselect,
  onSearch,
  error,
  placeholder,
  disabled,
  showSearch,
  showArrow,
  allowClear,
  mode,
  loading,
  filterOption,
  className = ' ',
  testId,
}: MSelectProps) => {
  return (
    <Row className={cx(className)}>
      <Col span={24}>
        <Select
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          onSelect={onSelect}
          onDeselect={onDeselect}
          onSearch={onSearch}
          placeholder={placeholder ?? 'Select'}
          bordered={false}
          disabled={disabled}
          showSearch={showSearch}
          showArrow={showArrow}
          allowClear={allowClear}
          mode={mode}
          loading={loading}
          filterOption={filterOption}
          clearIcon={<CloseOutlined />}
          dropdownRender={menu => (
            <>
              {loading ? (
                <Row justify='center' align='middle'>
                  <MSpinner height='100px' />
                </Row>
              ) : (
                menu
              )}
            </>
          )}
          className={cx(Styles.select(Boolean(value)), className)}
          data-testid={testId + '-' + 'value'}>
          {options.map(option => (
            <Option key={`menu_item_${option.value}`} value={option.value} label={option.label}>
              {option.label}
            </Option>
          ))}
        </Select>
      </Col>
      <Col span={24}>
        <MFormItemError value={error} data-testid={testId + '-' + 'error'} />
      </Col>
    </Row>
  );
};
